class SkeletonLoader {
  constructor(element) {
    this._element = element;
  }
}

export default SkeletonLoader;
